module.exports = __webpack_public_path__ + "img/team3.689ee33d.png";